<template>
  <div>
    <v-top></v-top>
    <v-nav></v-nav>
    <router-view></router-view>
    <v-footer></v-footer>
  </div>
</template>

<script>
import vTop from '@/components/education/Top'
import vNav from '@/components/common/Nav'
import vFooter from '@/components/common/TourFooter'

export default {
  name: 'TeacherLayout',
  components: {
    vTop,
    vNav,
    vFooter
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/teacher/Layout.vue